import { render, staticRenderFns } from "./Silver.vue?vue&type=template&id=454ca218"
import script from "./Silver.vue?vue&type=script&lang=js"
export * from "./Silver.vue?vue&type=script&lang=js"
import style0 from "./Silver.vue?vue&type=style&index=0&id=454ca218&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports